/**
 * @module:  新版黄豆接口参数修改（企业版）招贤纳士；（个人版）黄豆纳才
 * @author: Liang Huang 
 * @date: 2019-12-09 15:47:16 
 */
/**
 * 请求参数附带role参数
 * @param type 1:企业版；2:个人版
 */
import resident from '@src/store/resident'
import zhaopin from '@src/store/zhaopin'
import { urlFn } from '@src/utils/index';
import {html} from '@clouderwork/ywk'
export function withRole(param, type = 1) {
  const role = type === 1 ? 'company': 'person';
  return {...param, role};
}

// 基础数据转换为文字
export function changeBasic(name, id) {
  const flag = urlFn.getFirstPathName();
  let baseData = zhaopin.user.baseData;
  if (flag === 'resident') {
    baseData = resident.user.baseData;
  }
  const data:string[] =  []
  baseData&&baseData[name]&&baseData[name].forEach((cur) => {
    if (cur.id === id) {
      data.push(cur.name)
    }
  })
  return data
}

export function changeBr (val) {
  // 后端返回br标签先转化成/n, 然后将标签<>转化成转义符，在将/n转化成br标签
  return html.formatWrapTextIn(html.encodeHtml(html.formatWrapTextOut(val)))
}